import { Flex } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { addBusinessDays, subBusinessDays } from '@melio/melio-business-days';
import {
  FinancialInstitutions,
  ReconDetailsBankRecord,
  type TransferSearchMode
} from '@melio/payments-recon-api-client-ts';
import { Tag } from '@tools/ui/components/common/Tag';
import { IconSize, IconType, IconWrap, semanticTheme } from '@tools/ui/dime';
import { theme } from '@tools/ui-utils/theme.util';
import { reconEnumValue } from '../../../utils/reconEnumValue';
import LinkToTransferSearch from './link-to-transfer-search';

type IProps = {
  bankRecord: ReconDetailsBankRecord;
  mode?: TransferSearchMode;
  iconType?: IconType;
};

const ClickableTag = styled(Tag)`
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.gray.grayLight};
  }
`;

const TransferIdsCell: FC<React.PropsWithChildren<IProps>> = ({
  bankRecord,
  mode = reconEnumValue<TransferSearchMode>('normal'),
  iconType = IconType.Search
}) => {
  const recordId = bankRecord.recordId!;
  const transferIds = bankRecord.transferIds!;

  if (!transferIds?.length) {
    return (
      <LinkToTransferSearch
        filters={
          mode === reconEnumValue<TransferSearchMode>('normal')
            ? {
                from: subBusinessDays(
                  new Date(bankRecord.transactionDate!),
                  1
                ).toString(),
                to: addBusinessDays(
                  new Date(bankRecord.transactionDate!),
                  1
                ).toString(),
                direction: bankRecord.direction,
                fromAmount: bankRecord.amount,
                toAmount: bankRecord.amount,
                financialInstitution:
                  bankRecord.financialInstitution as FinancialInstitutions,
                mode
              }
            : { id: bankRecord.recordId, mode }
        }
      >
        <Flex align="center" gap={semanticTheme.dime.spacing.m}>
          <IconWrap type={iconType} size={IconSize.Small} />
          Locate
        </Flex>
      </LinkToTransferSearch>
    );
  }

  if (transferIds.length === 1) {
    return transferIds[0] ? (
      <Flex align="center" gap={semanticTheme.dime.spacing.m}>
       <LinkToTransferSearch filters={{ id: transferIds[0] }} maxWidth={80}>
          <IconWrap type={IconType.Show} size={IconSize.Small} style={{marginRight: semanticTheme.dime.spacing.m}}
          />
          {transferIds[0]}
        </LinkToTransferSearch>
      </Flex>
    ) : (<></>);
  }

  return (
    <LinkToTransferSearch filters={{ id: recordId }}>
      <ClickableTag>{transferIds.length} Transfers</ClickableTag>
    </LinkToTransferSearch>
  );
};

export default TransferIdsCell;
